export const freeCellGameState = {
    gameId: 'fr-01251',
    columns: [
        [
            { code: '91', visible: true },
            { code: '82', visible: true },
        ],

        [
            { code: 'Q0', visible: true },
            { code: '92', visible: true },
        ],
        [{ code: 'K3', visible: true }],
        [],
        [
            { code: 'K2', visible: true }, //
            { code: 'K1', visible: true },
            { code: 'J1', visible: true },
        ],
        [{ code: 'T2', visible: true }],
        [
            { code: 'Q2', visible: true },
            { code: 'K0', visible: true },
        ],
        [{ code: 'Q1', visible: true }],
    ],
    foundation: [
        [
            { code: 'A0', visible: true },
            { code: '20', visible: true },
            { code: '30', visible: true },
            { code: '40', visible: true },
            { code: '50', visible: true },
            { code: '60', visible: true },
            { code: '70', visible: true },
            { code: '80', visible: true },
            { code: '90', visible: true },
            { code: 'T0', visible: true },
            { code: 'J0', visible: true },
        ],
        [
            { code: 'A2', visible: true },
            { code: '22', visible: true },
            { code: '32', visible: true },
            { code: '42', visible: true },
            { code: '52', visible: true },
            { code: '62', visible: true },
            { code: '72', visible: true },
        ],
        [
            { code: 'A3', visible: true },
            { code: '23', visible: true },
            { code: '33', visible: true },
            { code: '43', visible: true },
            { code: '53', visible: true },
            { code: '63', visible: true },
            { code: '73', visible: true },
            { code: '83', visible: true },
            { code: '93', visible: true },
            { code: 'T3', visible: true },
            { code: 'J3', visible: true },
            { code: 'Q3', visible: true },
        ],
        [
            { code: 'A1', visible: true },
            { code: '21', visible: true },
            { code: '31', visible: true },
            { code: '41', visible: true },
            { code: '51', visible: true },
            { code: '61', visible: true },
            { code: '71', visible: true },
            { code: '81', visible: true },
        ],
    ],
    name: 'Freecell',
    movesCount: 31,
    moves: [],
    attempts: 3,
    score: 0,
    time: -321510.39999985695,
    freeCells: [[{ code: 'J2', visible: true }], [{ code: 'T1', visible: true }], [], []],
};

export const freeCellGameState2 = {
    gameId: 'fr-01251',
    columns: [
        [{ code: 'K3', visible: true }],
        [
            { code: '62', visible: true },
            { code: '50', visible: true },
            { code: '42', visible: true },
        ],
        [
            { code: 'T2', visible: true },
            { code: '51', visible: true },
            { code: '22', visible: true },
            { code: '41', visible: true },
            { code: '90', visible: true },
            { code: '82', visible: true },
            { code: '70', visible: true },
        ],
        [
            { code: 'J1', visible: true },
            { code: 'K1', visible: true },
            { code: '91', visible: true },
            { code: '71', visible: true },
            { code: 'J2', visible: true },
            { code: 'T0', visible: true },
            { code: '92', visible: true },
            { code: '80', visible: true },
            { code: '72', visible: true },
        ],
        [{ code: 'T0', visible: true }],
        [
            { code: 'J3', visible: true },
            { code: 'K2', visible: true },
            { code: 'Q0', visible: true },
        ],
        [
            { code: '61', visible: true },
            { code: '52', visible: true },
            { code: '40', visible: true },
            { code: '32', visible: true },
        ],
        [
            { code: 'K0', visible: true },
            { code: 'Q2', visible: true },
            { code: 'J0', visible: true },
        ],
    ],
    foundation: [
        [{ code: 'A2', visible: true }],
        [
            { code: 'A1', visible: true },
            { code: '21', visible: true },
            { code: '31', visible: true },
        ],
        [
            { code: 'A3', visible: true },
            { code: '23', visible: true },
            { code: '33', visible: true },
            { code: '43', visible: true },
            { code: '53', visible: true },
            { code: '63', visible: true },
            { code: '73', visible: true },
            { code: '83', visible: true },
            { code: '93', visible: true },
            { code: 'T3', visible: true },
        ],
        [
            { code: 'A0', visible: true },
            { code: '20', visible: true },
            { code: '30', visible: true },
        ],
    ],
    name: 'Freecell',
    movesCount: 31,
    moves: [],
    attempts: 3,
    score: 0,
    time: -321510.39999985695,
    freeCells: [[{ code: '81', visible: true }], [{ code: 'Q3', visible: true }], [], [{ code: 'Q1', visible: true }]],
};

export const spiderGameState = {
    gameId: 'sp1-02569',
    columns: [
        [
            { code: '53', visible: true },
            { code: 'A3', visible: true },
        ],
        [
            { code: 'J3', visible: true },
            { code: 'T3', visible: true },
            { code: '93', visible: true },
            { code: '83', visible: true },
            { code: '43', visible: true },
        ],
        [
            { code: 'T3', visible: true },
            { code: '93', visible: true },
            { code: '83', visible: true },
            { code: '73', visible: true },
            { code: 'K3', visible: true },
        ],
        [
            { code: 'K3', visible: true },
            { code: '33', visible: true },
        ],
        [
            { code: 'A3', visible: true },
            { code: '63', visible: true },
        ],
        [
            { code: '23', visible: true },
            { code: '73', visible: true },
        ],
        [{ code: '33', visible: true }],
        [
            { code: '43', visible: true },
            { code: '23', visible: true },
        ],
        [
            { code: '53', visible: true },
            { code: 'Q3', visible: true },
            { code: 'J3', visible: true },
        ],
        [
            { code: '63', visible: true },
            { code: 'Q3', visible: true },
        ],
    ],
    foundation: [
        [
            { code: 'A3', visible: true },
            { code: '23', visible: true },
            { code: '33', visible: true },
            { code: '43', visible: true },
            { code: '53', visible: true },
            { code: '63', visible: true },
            { code: '73', visible: true },
            { code: '83', visible: true },
            { code: '93', visible: true },
            { code: 'T3', visible: true },
            { code: 'J3', visible: true },
            { code: 'Q3', visible: true },
            { code: 'K3', visible: true },
        ],
        [
            { code: 'A3', visible: true },
            { code: '23', visible: true },
            { code: '33', visible: true },
            { code: '43', visible: true },
            { code: '53', visible: true },
            { code: '63', visible: true },
            { code: '73', visible: true },
            { code: '83', visible: true },
            { code: '93', visible: true },
            { code: 'T3', visible: true },
            { code: 'J3', visible: true },
            { code: 'Q3', visible: true },
            { code: 'K3', visible: true },
        ],
        [
            { code: 'A3', visible: true },
            { code: '23', visible: true },
            { code: '33', visible: true },
            { code: '43', visible: true },
            { code: '53', visible: true },
            { code: '63', visible: true },
            { code: '73', visible: true },
            { code: '83', visible: true },
            { code: '93', visible: true },
            { code: 'T3', visible: true },
            { code: 'J3', visible: true },
            { code: 'Q3', visible: true },
            { code: 'K3', visible: true },
        ],
        [
            { code: 'A3', visible: true },
            { code: '23', visible: true },
            { code: '33', visible: true },
            { code: '43', visible: true },
            { code: '53', visible: true },
            { code: '63', visible: true },
            { code: '73', visible: true },
            { code: '83', visible: true },
            { code: '93', visible: true },
            { code: 'T3', visible: true },
            { code: 'J3', visible: true },
            { code: 'Q3', visible: true },
            { code: 'K3', visible: true },
        ],
        [
            { code: 'A3', visible: true },
            { code: '23', visible: true },
            { code: '33', visible: true },
            { code: '43', visible: true },
            { code: '53', visible: true },
            { code: '63', visible: true },
            { code: '73', visible: true },
            { code: '83', visible: true },
            { code: '93', visible: true },
            { code: 'T3', visible: true },
            { code: 'J3', visible: true },
            { code: 'Q3', visible: true },
            { code: 'K3', visible: true },
        ],
        [
            { code: 'A3', visible: true },
            { code: '23', visible: true },
            { code: '33', visible: true },
            { code: '43', visible: true },
            { code: '53', visible: true },
            { code: '63', visible: true },
            { code: '73', visible: true },
            { code: '83', visible: true },
            { code: '93', visible: true },
            { code: 'T3', visible: true },
            { code: 'J3', visible: true },
            { code: 'Q3', visible: true },
            { code: 'K3', visible: true },
        ],
        [],
        [],
    ],
    name: 'Spider',
    movesCount: 120,
    moves: [],
    attempts: 0,
    score: 980,
    time: -320550.40000003576,
    stockpile: [],
};

export const KlondikeMockStore = {
    gameId: 'kl1-00018',
    columns: [
        [{ code: 'Q2', visible: true }],
        [
            { code: '52', visible: true },
            { code: '40', visible: true },
            { code: '31', visible: true },
        ],
        [
            { code: '82', visible: false },
            { code: '93', visible: true },
        ],
        [{ code: '92', visible: true }],
        [
            { code: '52', visible: false },
            { code: '43', visible: false },
            { code: '33', visible: true },
        ],
        [
            { code: 'J0', visible: false },
            { code: 'T3', visible: false },
            { code: '93', visible: false },
            { code: '63', visible: true },
            { code: '50', visible: true },
            { code: '42', visible: true },
        ],
        [{ code: '43', visible: true }],
    ],
    foundation: [
        [{ code: 'A1', visible: true }],
        [
            { code: 'A0', visible: true },
            { code: '20', visible: true },
        ],
        [],
        [],
    ],
    name: 'Klondike',
    movesCount: 46,
    moves: [],
    attempts: 0,
    score: 100,
    time: -528507.2000000775,
    wastePile: [
        { code: '61', visible: true },
        { code: 'T3', visible: true },
        { code: 'A3', visible: true },
    ],
    stockpile: [],
};
